import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export async function exportarParaExcel(dados, nomeArquivo = 'arquivo.xlsx', nomeAba = 'Dados') {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(nomeAba)

  if (!dados || !dados.length) return

  // cabeçalhos
  const colunas = Object.keys(dados[0]).map(key => ({
    header: key,
    key: key
  }))

  worksheet.columns = colunas

  dados.forEach(item => {
    worksheet.addRow(item)
  })

  // insere estilo no cabeçalho
  worksheet.getRow(1).eachCell(cell => {
    cell.font = { bold: true }
    cell.alignment = { vertical: 'middle', horizontal: 'center' }

    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }

    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD9D9D9' }
    }
  })

  // insere bordas em todas as células
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    })
  })

  // 📏 Auto-size
  worksheet.columns.forEach(column => {
    let maxLength = 10

    column.eachCell({ includeEmpty: true }, cell => {
      const value = cell.value ? cell.value.toString() : ''
      maxLength = Math.max(maxLength, value.length)
    })

    column.width = maxLength + 4
  })

  // 💾 Gerar arquivo
  const buffer = await workbook.xlsx.writeBuffer()
  saveAs(new Blob([buffer]), nomeArquivo)
}